import React, { useMemo } from 'react';
import AuthActionHandler from '../features/auth/components/AuthActionHandler';

const SetupAccount = ({ onNavigate }) => {
    const params = useMemo(() => new URLSearchParams(window.location.search), []);
    const mode = params.get('mode');
    const oobCode = params.get('oobCode');

    if ((mode === 'resetPassword' || mode === 'verifyEmail') && oobCode) {
        return <AuthActionHandler mode={mode} oobCode={oobCode} onNavigate={onNavigate} />;
    }

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6">
            <div className="bg-white w-full max-w-md rounded-2xl border border-gray-200 shadow-xl p-6 text-center">
                <div className="text-sm font-bold text-gray-800">Ativação de conta</div>
                <div className="mt-2 text-xs text-gray-500 whitespace-pre-wrap">
                    Este link não contém um código de ativação válido.
                    \n\nAbra o link enviado por e-mail novamente.
                </div>
                <button
                    type="button"
                    onClick={() => onNavigate('client')}
                    className="mt-6 w-full bg-brand-blue text-white py-3 rounded-lg font-bold shadow-lg hover:bg-brand-blue-darker transition-all"
                >
                    IR PARA LOGIN
                </button>
            </div>
        </div>
    );
};

export default SetupAccount;